import { isProduction, isHbDevServer, getDevPortOffset, DEV_SERVER_HOST } from '@honeybook/utils-web';
const manifestBaseUrlForProduction = '/manifests/';
function withCacheBuster(manifestUrl) {
    return `${manifestUrl}?t=${Date.now()}`;
}
export async function fetchRemoteManifestData(appData) {
    const { manifestFileName, devServer } = appData;
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? 'https'
        : 'http';
    const localhostBaseUrl = `${protocol}://localhost`;
    const proxyBaseUrl = `${protocol}://${DEV_SERVER_HOST}`;
    // apps.json holds base ports; shift by the dev port-cluster offset so a
    // worktree env on cluster k fetches its remotes from 71xx + 100k.
    const localhostOrigin = `${localhostBaseUrl}:${devServer.port + getDevPortOffset()}/`;
    let manifestBaseUrl;
    let basePublicPath;
    if (isHbDevServer()) {
        manifestBaseUrl = `${proxyBaseUrl}/`;
        basePublicPath = `${proxyBaseUrl}/`;
    }
    else if (isProduction()) {
        manifestBaseUrl = manifestBaseUrlForProduction;
        basePublicPath = null;
    }
    else {
        manifestBaseUrl = localhostOrigin;
        basePublicPath = localhostOrigin;
    }
    try {
        const response = await fetch(withCacheBuster(`${manifestBaseUrl}${manifestFileName}`), { cache: 'no-store' });
        if (!response.ok) {
            throw new Error(`Failed to fetch manifest: ${response.statusText}`);
        }
        const manifest = await response.json();
        const publicPath = isProduction()
            ? manifest.metaData.publicPath
            : basePublicPath;
        return {
            entryFileName: manifest.metaData.remoteEntry.name,
            buildVersion: manifest.metaData.buildInfo.buildVersion,
            publicPath
        };
    }
    catch (error) {
        console.error('Error fetching remote manifest:', error);
        return null;
    }
}
//# sourceMappingURL=fetch-remote-manifest-data.js.map